import React from 'react'
import styled from 'styled-components'
import { RangeNumberBox } from 'components/scouts/request-form/slider'
import { Row } from 'components/common/layout'
import { FiMinus } from 'react-icons/fi'
import { theme } from 'infra/theme'

export const RangeSliderValueDisplay: React.FC<{
  min: number
  max: number
  value: number | number[]
  unit: string
}> = ({ min, max, value, unit }) => {
  if (typeof value === 'number') {
    // value가 number이면 max값만 전달된 것으로 간주
    const maxValue = value.toLocaleString()
    const isMaxEqual = value === max
    return (
      <RowWithGap>
        <RangeText>
          {maxValue}
          {unit}
          {isMaxEqual ? ' 이상' : ''}
        </RangeText>
      </RowWithGap>
    )
  } else {
    // value가 number[]이면 [min, max] 형태로 전달됨
    const [vMin, vMax] = value
    const minValue = vMin.toLocaleString()
    const maxValue = vMax.toLocaleString()
    const isMinEqual = vMin === min
    const isMaxEqual = vMax === max

    // 만약 두 값이 동일할 경우 단일 값만 표시
    if (!isMinEqual && !isMaxEqual && minValue === maxValue) {
      return (
        <RowWithGap>
          <RangeText>
            {minValue}
            {unit}
          </RangeText>
        </RowWithGap>
      )
    }
    return (
      <RowWithGap>
        {isMinEqual && isMaxEqual && <RangeText>전체</RangeText>}
        {!isMinEqual && (
          <RangeText>
            {minValue}
            {unit} 이상
          </RangeText>
        )}
        {!isMinEqual && !isMaxEqual && (
          <FiMinus
            size={8}
            strokeWidth={4}
            color={theme.color.black3}
            style={{ flex: 'none' }}
          />
        )}
        {!isMaxEqual && (
          <RangeText>
            {maxValue}
            {unit} 이하
          </RangeText>
        )}
      </RowWithGap>
    )
  }
}

const RowWithGap = styled(Row)`
  gap: 8px;
`

const RangeText = styled(RangeNumberBox)`
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.small};
  }
`
